import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Typography } from 'antd';

const { Title, Text } = Typography

const ErrorNotFound = () => {
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    const intervalId = setTimeout(() => setShouldRedirect(true), 2000)

    return () => {
      clearTimeout(intervalId)
    }
  }, [])

  return shouldRedirect
    ? <Navigate to="/" />
    : (
      <div id="error">
        <Title level={1}><FormattedMessage id="ErrorNotFound" /></Title>
        <Title level={2}><FormattedMessage id="ErrorNotFound.Description" /></Title>
        <Text><FormattedMessage id="ErrorNotFound.Description2" /></Text>
      </div>
    )
}

export default ErrorNotFound;
